import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { unlockUser } from "service/userservice/unlockUser";
import { useAuthorizationCheck } from "hooks/useAuthorizationCheck";
import { AgentLicensesContainer } from "components/AgentPortal/AgentLicenses/AgentLicensesContainer";
import { UnlockUserConfirmationModel } from "components/ModalDialogs/UnlockUserConfirmationModel";
import { deactivateUser as deactivateSelectedUser } from "service/userservice/deactivateUser";
import { removeUser } from "redux/slices/userSlice";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import AssistantInfoDialog from "components/AgentPortal/AgentProfile/Dialogs/AssistantInfoDialog";
import ProfileCard from "components/AgentPortal/AgentProfile/AgentProfileCard";
import SimpleCallToActionCard from "components/General/SimpleCallToActionCard";
import SimpleCTAToDialogCard from "components/General/SimpleCTAToDialogCard";
import UserInfoDialog from "components/AgentPortal/AgentProfile/Dialogs/UserInfoDialog";
import UserSecurityDialog from "components/AgentPortal/AgentProfile/Dialogs/UserSecurityDialog";
import GeneralActionButtonsModal from "components/General/GeneralActionButtonsModal";
import config from "config/config";

const Profile = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const { t } = useTranslation();
  const [openUserInfoDialog, setOpenUserInfoDialog] = useState(false);
  const [openUserSecurityDialog, setOpenUserSecurityDialog] = useState(false);
  const { user } = useSelector((s) => s.user);
  const { csrUser } = useSelector((s) => s.csrUser);
  const [isUnlockUserConfirmation, setIsUnlockUserConfirmation] =
    useState(false);
  const [openAgentAssistantDialog, setopenAgentAssistantDialog] =
    useState(false);
  // for getting user ID
  const { agent } = useSelector((s) => s.getAgent);
  const [agentInfo, setAgentInfo] = useState();
  const [deactivateUser, setDeactivateUser] = useState(false);
  useEffect(() => {
    setAgentInfo(agent?.parties);
  }, [agent, user]);
  useBreadcrumb([
    { name: "Home", url: "/dashboard" },
    { name: "Profile", url: "#" },
  ]);
  async function unlock() {
    // portal api call for unlock user
    console.log("Unlock the account", user);
    const userUnlockResponse = await unlockUser(user?.userId).catch((error) => {
      console.log(error);
    });
    if (userUnlockResponse?.ok) {
      setIsUnlockUserConfirmation(true);
    } else {
      console.log("Server was unable to connect, please try again later.");
    }
  }

  async function deactivate() {
    // portal api call for deactivate user
    await deactivateSelectedUser(user?.userId)
      .then((response) => {
        if (response) {
          dispatch(removeUser());
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setDeactivateUser(false);
  }

  return (
    <>
      {/* SPRINT-9-AGENT-help-sales-and-search.pdf (pg. 17) */}
      <div className="container mb-8">
        <h1>{t("AgentProfile-title")}</h1>
        <div className="flex justify-between">
          <p>{t("AgentProfile-subTitle")}</p>
          {csrUser?.userId && (
            <>
              <div className="flex justify-end">
                <button className="ui-btn-primary" onClick={() => unlock()}>
                  {t("AgentProfile-button1")}
                </button>
                <button
                  className="ui-btn-primary"
                  onClick={() => setDeactivateUser(true)}
                >
                  {t("AgentProfile-button2")}
                </button>
              </div>
            </>
          )}
        </div>
        <hr />
      </div>

      {/* Profile Details */}
      <ProfileCard agentProfile={agentInfo} data={agent} />

      {/* Manage my information & Preferences */}
      <div className="container ui-component-spacing">
        <h2>{t("AgentProfile-title2")}</h2>
        <p className="text-sm">{t("AgentProfile-subTitle2")}</p>
        <hr />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:gap-6">
          {/* <SimpleCTAToDialogCard
            title="Contact Info"
            desc="Update your email, phone number and address"
            ctaText="Update"
            openDialog={() => setOpenUserInfoDialog(true)}
          /> */}
          {/* Contact Information */}
          <UserInfoDialog
            agentProfile={agentInfo}
            dialogState={openUserInfoDialog}
            setDialogState={setOpenUserInfoDialog}
          />

          <SimpleCTAToDialogCard
            title={t("AgentProfile-cardTitle1")}
            desc={t("AgentProfile-cardDescription1")}
            ctaText={t("AgentProfile-cardButton1")}
            openDialog={() => setOpenUserSecurityDialog(true)}
          />
          {/* Security Settings */}
          <UserSecurityDialog
            dialogState={openUserSecurityDialog}
            setDialogState={setOpenUserSecurityDialog}
          />
          <UnlockUserConfirmationModel
            isUnlockUserConfirmation={isUnlockUserConfirmation}
            setIsUnlockUserConfirmation={setIsUnlockUserConfirmation}
          />
          {useAuthorizationCheck(26) && (
            <>
              <SimpleCallToActionCard
                title={t("AgentProfile-cardTitle2")}
                desc={t("AgentProfile-cardDescription2")}
                ctaText={t("AgentProfile-cardButton1")}
                ctaUrl="/profile/assistant-details"
                /*openDialog={() => setopenAgentAssistantDialog(true)}*/
              />
              {/*Manage AgentAssistant Preferences */}
              <AssistantInfoDialog
                dialogState={openAgentAssistantDialog}
                setDialogState={setopenAgentAssistantDialog}
              />
            </>
          )}
        </div>
      </div>

      {/* Agent Licenses */}
      {config.COMPANY_NAME === "everlake" && (
        <AgentLicensesContainer data={agent} agentLicenses={agent?.licenses} />
      )}

      <GeneralActionButtonsModal
        title={t("AgentProfile-modalTitle")}
        primaryButtonText={t("AgentProfile-modalButton1")}
        secondaryButtonText={t("AgentProfile-modalButton2")}
        dialogState={deactivateUser}
        setDialogState={setDeactivateUser}
        primaryButtonAction={deactivate}
      />

      {/* Other Settings */}
      {/* <div className="container ui-component-spacing">
        <h2>Other Settings</h2>
        <p className="text-sm">
          Subtitle explaining this group of functions goes here
        </p>
        <hr />

        <div className="grid grid-cols-1 gap-4 auto-rows-fr sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {settings.map((item, idx) => (
            <AppNavigationCard
              key={idx}
              icon={item.icon}
              title={item.title}
              desc={item.desc}
              url={item.url}
            />
          ))}
        </div>
      </div> */}
    </>
  );
};

export default Profile;
